declare var ROOT: any;


export default class {
  constructor() {
    this.init();
  }
  init(){
    let mql:MediaQueryList = window.matchMedia('(min-width: 769px)');
    mql.addListener(this.pcSp);
    this.pcSp(mql);

    mql = window.matchMedia('(orientation: portrait)');
    mql.addListener(this.orientation);
    this.orientation(mql);

    window.addEventListener('resize', this.resize);
    this.resize()
  }
  resize(){
    ROOT.s={
      W:window.innerWidth,
      h:window.innerHeight
    }
    let vh = Math.max(ROOT.s.W, ROOT.s.H) * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty(
      '--scale',
      Math.min(1, ROOT.s.H / 820).toString()
    );
  }
  pcSp(mql){
    if (mql.matches) {
      ROOT.isSp=false;
      // console.log('769px以上');
    } else {
      ROOT.isSp=true;
      // console.log('769px未満');
    }
  }
  orientation(mql){
    if (mql.matches) {
      ROOT.isPortrait=true;
      // console.log('portrait');
    } else {
      ROOT.isPortrait=false;
      // console.log('landscape');
    }
  }
}
